export default __webpack_public_path__ + "static/media/06.a2e7376f.jpg";